import { ExclamationCircleFilled } from "@ant-design/icons";
import { Col, Modal, Row, message } from "antd";
import { Dispatch, SetStateAction, useContext, useRef } from "react";
import { handleMakePayment } from "../../CheckoutNew";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "react-query";
import { Sale, createSale } from "../../../../api/sales";
import { mainActions } from "../../../../store/main/mainSlice";
import { useTranslation } from "react-i18next";
import { exchangeRateContext } from "../../MainFour";

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const HoldOrderTwo = ({ open, setOpen }: Props) => {
  const [t] = useTranslation("common");
  const items = useSelector((state: any) => state.main.items);
  const customer = useSelector((state: any) => state.main.customer);
  const discount = useSelector((state: any) => state.main.discount);
  const sessionId = useRef(localStorage.getItem("sessionId"));
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;
  const invoiceNo = useSelector((state: any) => state.main.invoiceNo);
  const { exchangeRate } = useContext(exchangeRateContext);
  const { mutateAsync: createSaleMutation, isLoading } = useMutation(
    "createSale",
    (body: Sale) => createSale(body)
  );
  const dispatch = useDispatch();

  const currentDate = new Date();
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;

  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        onCancel={() => {
          setOpen(false);
          document.body.classList.remove("body-scroll-lock");
        }}
        open={open}
        centered
        confirmLoading={isLoading}
        title={
          <>
            <Row>
              <Col span={3}>
                <ExclamationCircleFilled
                  style={{
                    color: "#FFBC39",
                    fontSize: "45px",
                    marginTop: "22px",
                  }}
                />
              </Col>

              <Col span={19}>
                <Col
                  style={{
                    fontSize: "32px",
                    color: "#212121",
                  }}
                >
                  {" "}
                  {t("confirm-hold")}
                </Col>
                <Col
                  span={19}
                  style={{
                    fontSize: "16px",
                    color: "#212121",
                    wordWrap: "break-word",
                  }}
                >
                  {t("please-confirm-hold")}
                </Col>
              </Col>
            </Row>
          </>
        }
        onOk={() => {
          handleMakePayment(
            true,
            formattedDate,
            items,
            createSaleMutation,
            customer,
            discount,
            mainCurrency,
            sessionId,
            invoiceNo,
            exchangeRate
          ).then((response) => {
            message.success({
              content: response.data.message,
              duration: 3,
              onClick: () => {
                message.destroy();
              },
            });
            setOpen(false);
            dispatch(mainActions.clearInvoice());
            document.body.classList.remove("body-scroll-lock");
          }).catch(({ response }) => {
            message.error({
              content: response.data.message,
              duration: 5,
              onClick: () => {
                message.destroy();
              },
            });
            setOpen(false)
            document.body.classList.remove("body-scroll-lock");
          });
        }
        }
        okText={isLoading ? <></> : `${t("confirm")}`}
        cancelText={`${t("cancel")}`}
        okButtonProps={{ style: { height: "40px" } }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            marginInlineEnd: "auto",
            height: "40px",
          },
        }}
      />
    </>
  );
};

export default HoldOrderTwo;
